(function () {
    'use strict';
    angular.module('SMART2').directive('onLoad', ['$timeout', function ($timeout) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                onLoadCallback: '&',
            },
            link: function (scope, element, attrs) {
                (scope.onLoadCallback) ? scope.onLoadCallback = scope.$eval(scope.onLoadCallback) : null;
                if (angular.isFunction(scope.onLoadCallback)) {
                    $timeout(function () {
                        scope.onLoadCallback();
                    }, 0);
                }
            }
        };
    }]);
})();
